import React from 'react'
import styled from '@emotion/styled'

import { Box } from '../Box/Box'
import { Icon } from '../Icon/Icon'
import { Text } from '../Text/Text'
import { Inline } from '../Inline/Inline'

export interface CheckboxProps extends BaseProps {
  id: string
  checked: boolean
  onChange?: () => void
  label: string
}

const BaseCheckbox: React.FC<CheckboxProps> = ({ id, checked, label, onChange, ...props }) => {
  const border = checked ? '2px solid var(--colors-action)' : '2px solid var(--colors-subtle)'
  const background = checked ? 'var(--colors-action)' : 'transparent'

  return (
    <div {...props}>
      <CheckboxInput type="checkbox" id={id} onChange={onChange} />
      <Inline space="s" alignY="center">
        <CheckmarkWrapper
          position="relative"
          radius="xxs"
          border={border}
          background={background}
          height="20px"
          width="20px"
          transition="all var(--transition)"
        >
          <Checkmark name="checkmark" size="s" noTone />
        </CheckmarkWrapper>
        <Label component="label" htmlFor={id}>
          {label}
        </Label>
      </Inline>
    </div>
  )
}

const CheckboxInput = styled.input`
  position: absolute;
  top: -5px;
  left: -5px;
  height: 30px;
  width: 40px;
  outline: none;
  opacity: 0;
  margin: 0;
  cursor: pointer;
`

const CheckmarkWrapper = styled(Box)`
  pointer-events: none;
`

const Checkmark = styled(Icon)`
  opacity: 0;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: opacity var(--transition);
`

export const Checkbox = styled(BaseCheckbox)`
  position: relative;
  color: var(--colors-subtle);

  ${(p) =>
    p.checked &&
    `
    svg {
      color: var(--colors-contrast);
      opacity: 1;      
    }
  `}
`

const Label = styled(Text)`
  cursor: pointer;
  user-select: none;
`
